import React, { useState, useEffect } from 'react';

const LoadingScreen = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setFadeOut(true);
      setTimeout(() => setIsLoading(false), 600);
    }, 1800);

    return () => clearTimeout(timer);
  }, []);

  if (!isLoading) return null;

  return (
    <div className={`loading-screen-pro ${fadeOut ? 'fade-out' : ''}`}>
      <div className="loading-content-pro">
        {/* Logo */}
        <div className="loading-logo-pro">
          <img 
            src="https://customer-assets.emergentagent.com/job_portfolio-pro-505/artifacts/6rf6onic_885ea933-b00e-4489-80dc-ff243e4d3458-removebg-preview.png" 
            alt="Green Art Logo" 
            className="loading-logo-image-pro"
          />
        </div>

        {/* Slogan */}
        <h2 className="loading-slogan-pro">More Green in Every Scene</h2>

        {/* Simple progress indicator */}
        <div className="loading-spinner-pro">
          <div className="spinner-circle"></div>
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;
